/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Pricing_EyebrowInputs */

const en_endpoint_pricing_eyebrow = /** @type {(inputs: Endpoint_Pricing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing`)
};

const zh_hans1_endpoint_pricing_eyebrow = /** @type {(inputs: Endpoint_Pricing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价格`)
};

const pt_br2_endpoint_pricing_eyebrow = /** @type {(inputs: Endpoint_Pricing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preços`)
};

const es_endpoint_pricing_eyebrow = /** @type {(inputs: Endpoint_Pricing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precios`)
};

const fr_endpoint_pricing_eyebrow = /** @type {(inputs: Endpoint_Pricing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarifs`)
};

const de_endpoint_pricing_eyebrow = /** @type {(inputs: Endpoint_Pricing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preise`)
};

const ru_endpoint_pricing_eyebrow = /** @type {(inputs: Endpoint_Pricing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цены`)
};

const it_endpoint_pricing_eyebrow = /** @type {(inputs: Endpoint_Pricing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzi`)
};

/**
* | output |
* | --- |
* | "Pricing" |
*
* @param {Endpoint_Pricing_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_pricing_eyebrow = /** @type {((inputs?: Endpoint_Pricing_EyebrowInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Pricing_EyebrowInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_pricing_eyebrow(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_pricing_eyebrow(inputs)
	if (locale === "es") return es_endpoint_pricing_eyebrow(inputs)
	if (locale === "fr") return fr_endpoint_pricing_eyebrow(inputs)
	if (locale === "de") return de_endpoint_pricing_eyebrow(inputs)
	if (locale === "ru") return ru_endpoint_pricing_eyebrow(inputs)
	if (locale === "it") return it_endpoint_pricing_eyebrow(inputs)
	return en_endpoint_pricing_eyebrow(inputs)
});